<template>
    <div v-if="hasSubmissions || errorHandlingMessage">
        <b-alert :show="!!errorHandlingMessage" variant="danger" dismissible>{{ errorHandlingMessage }}</b-alert>
        <h5 v-if="hasSubmissions" class="rounded bg-gray-100 p-2">
            <b-icon icon="file-earmark-spreadsheet" variant="primary" class="mr-2"></b-icon>
            Submission History
        </h5>
        <b-table
            v-if="hasSubmissions"
            :items="submissionList"
            :fields="tableFields"
            primary-key="id"
            small
            class="no-top-border rounded shadow-sm mb-0"
        >
            <template #cell(submitted_on)="data">
                <div class="text-nowrap">
                    {{ displayDate(data.value) }}
                    <span class="text-muted">{{ displayTime(data.value) }}</span>
                </div>
                <b-badge v-if="data.item.id === mostRecentSubmissionId" variant="soft-success" class="font-size-70 text-uppercase">Latest</b-badge>
            </template>
            <template #cell(submitted_by)="data">
                {{ data.value && data.value.full_name ? data.value.full_name : '-' }}
            </template>
            <template #cell(submit_note)="data">
                <span v-if="data.value" style="white-space: pre-line;">{{ data.value }}</span>
                <span v-else class="text-muted">-</span>
            </template>
            <template #cell(download)="data">
                <b-button :href="data.item.excel_download_url" size="sm" variant="gray-secondary" class="d-inline-flex align-items-center gap-2 text-nowrap">
                    <span class="fiv-sqo fiv-icon-xlsx font-size-120"></span>
                    <span class="font-size-70 text-uppercase">Download</span>
                </b-button>
            </template>
        </b-table>
    </div>
</template>

<script>
import { suppliosApi } from '../../js/api-service';
import { errorHandling } from '../../js/custom-vue-mixins';
import { DateTime } from 'luxon';
import orderBy from 'lodash/orderBy';

export default {
    name: 'RfxResponseSubmissionDownloadList',
    mixins: [
        errorHandling,
    ],
    props: {
        responseId: {
            type: [String, Number],
            required: true,
        }
    },
    data: function() {
        return {
            loading: false,
            submissionList: [],  // from API, not paginated - sorted most recent first
            mostRecentSubmissionId: '',  // set when processing API response
            tableFields: [
                { key: 'submitted_on', label: 'Submitted On', tdClass: 'align-middle' },
                { key: 'submitted_by', label: 'Submitted By', tdClass: 'align-middle' },
                { key: 'submit_note', label: 'Comments', tdClass: 'align-middle w-50' },
                { key: 'download', label: 'File', thClass: 'text-right', tdClass: 'align-middle text-right' },
            ],
        }
    },
    computed: {
        hasSubmissions() {
            return this.submissionList.length > 0;
        }
    },
    mounted() {
        this.getList();
    },
    methods: {
        // use this.apiErrorHandler(error, extraMsg, localMsg) from mixin - localMsg is bool, if true puts message in this.errorHandlingMessage
        async getList() {
            this.loading = true;
            let subList = [];
            try {
                const response = await suppliosApi.rfxResponse.list_submissions(this.responseId);
                subList = response.data;
            } catch (error) {
                this.apiErrorHandler(error, 'Could not load submissions.', true);
            }
            // sort most recent first, so the latest one is the first in the list
            const withTimestamp = subList.map(sub => {
                const ts = sub.submitted_on ? DateTime.fromISO(sub.submitted_on).toMillis() : null;
                return {...sub, submitted_on_ts: ts};
            });
            this.submissionList = orderBy(withTimestamp, ['submitted_on_ts'], ['desc']);
            this.mostRecentSubmissionId = this.submissionList.length ? this.submissionList[0].id : '';
            this.loading = false;
        },
        displayDate(dtString) {
            return dtString ? DateTime.fromISO(dtString).toLocaleString(DateTime.DATE_SHORT) : '';
        },
        displayTime(dtString) {
            return dtString ? DateTime.fromISO(dtString).toLocaleString(DateTime.TIME_SIMPLE) : '';  // will be user's local time
        },
    }
}
</script>
